import React, { useRef, useEffect } from "react";
import ReactDOM from 'react-dom/client';
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from 'react-i18next';

const UserTyping = () => {
  const { t, i18n } = useTranslation();
  const usersTyping = useSelector(state => state.app.usersTyping);

  return (
    <div className="kil-chat-widget-writting">
      {usersTyping.length > 0 &&
        <>
        <span>
          {usersTyping.map(typer => typer.username).join(', ')}
          {usersTyping.length == 1 &&
            <span>{t(" is typing...")}</span>
          }
          {usersTyping.length > 1 &&
            <span>{t(" are typing...")}</span>
          }
        </span>
        </>
      }
    </div>
  );
}

export default UserTyping;